import { BaseClient } from '../client';
import { dashboardAdminResumoMock } from './dashboard.mocks';
import { TDashboardAdminResumo } from './dashboardDealer.types';

export const getAdminDashboardResumo = async () => {
	// if (process.env.NODE_ENV === 'development') {
	// 	return dashboardAdminResumoMock;
	// }

	try {
		const response = await BaseClient.get<TDashboardAdminResumo>(`/Admin/GetAdminDashboardResumo`).then((response) => response.data);
		return response;
	} catch (error) {
		console.error(error);
	}
};

